import { css } from '@emotion/react';
import { gray5, primary } from 'styles/global_defaults/colors';
import {
  headerLineHeight,
  headerRegularLineHeight,
  textLargeLineHeight,
} from 'styles/global_defaults/fonts';
import { quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

const modalStyles = css`
  height: 800px;
  padding-left: 140px;
  padding-right: 140px;
  .step-number {
    width: ${standardSpacing}px;
    height: ${standardSpacing}px;
    border-radius: 50%;
  }
  .active-step {
    background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
  }
  .min-h-sm {
    min-height: 45px;
  }
  .min-h-lg {
    min-height: 140px;
  }
  .lh-35 {
    line-height: ${headerRegularLineHeight}px !important;
  }
  .lh-30 {
    line-height: ${textLargeLineHeight}px !important;
  }
  .lh-25 {
    line-height: ${headerLineHeight}px !important;
  }
  textarea:hover:not(:focus) {
    cursor: pointer !important;
    overflow-y: auto;
  }
  .required-textarea {
    .nv-text-area {
      box-shadow: 0 0 0 1px ${gray5};
      border-radius: ${quarterSpacing}px;
      &:focus-within {
        box-shadow: 0 0 0 1px ${primary};
      }
      textarea {
        background: transparent;
        border: none;
        box-shadow: none;
        outline: none;
      }
      .bs4-input-group-text {
        align-items: flex-start;
        background: transparent;
        border: none;
        margin: 1px;
      }
    }
  }
  .required-input {
    height: 45px;
    border-radius: ${quarterSpacing}px;
    box-shadow: 0 0 0 1px ${gray5};
    &:focus-within {
      box-shadow: 0 0 0 1px ${primary};
    }
    .nv-text-input {
      height: 100%;
      display: flex;
      align-items: center;
      border: none;
      input {
        height: 100%;
        background-color: transparent;
        border: none;
      }
      .input-required {
        .bs4-input-group-text {
          background-color: transparent;
          border: none;
          margin: 1px;
        }
      }
    }
  }
`;

export default modalStyles;
